import templateUrl from './admins-by-category-area.html';

export default {
  templateUrl,
  controller: class AdministrationsByCategoryAreaComponent {
    constructor($scope, LoadingService, AdminsByCategoryAreaService, ToastService) {
      'ngInject';

      Object.assign(this, {
        $scope,
        LoadingService,
        AdminsByCategoryAreaService,
        ToastService
      });
    }

    $onInit() {
      this.chartConfig = {
        chart: {
          zoomType: 'xy'
        },
        title: {
          text: 'Administrations By Category'
        },
        subtitle: {
          text: 'NASC Adverse Event Reporting System'
        },
        xAxis: {
          type: 'datetime',
          title: {
            style: {
              fontSize: '14px'
            }
          },
          labels: {
            style: {
              fontSize: '14px'
            }
          },
          tickInterval: 12 * 30 * 24 * 3600 * 1000 // for quarterly 3 * 30 * 24 * 3600 * 1000
        },
        yAxis: [{
          title: {
            text: 'Administrations (mil)',
            style: {
              color: window.Highcharts.getOptions().colors[1],
              fontSize: '14px'
            }
          },
          labels: {
            format: '{value} mil',
            style: {
              color: window.Highcharts.getOptions().colors[1],
              fontSize: '14px'
            }
          }
        }],
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:,.2f} mil</b></td></tr>',
          footerFormat: '</table>',
          split: true,
          useHTML: true
        },
        legend: {
          itemWidth: 180,
          itemDistance: 0,
          itemStyle: {
            fontSize: '14px'
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: false
            }
          },
          area: {
            stacking: 'normal',
            lineColor: '#666666',
            lineWidth: 1,
            marker: {
              enabled: false
            }
          }
        }
      };
    }

    generateReport({ params }) {
      this.LoadingService.start();
      this.AdminsByCategoryAreaService.getReport(params)
        .then((series) => {
          this.chartConfig.series = series;
        }).catch(error => this.ToastService.showError(error))
      .finally(() => {
        this.LoadingService.stop();
        this.$scope.$apply();
      });
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/reports/admins-by-category-area/admins-by-category-area.component.js